import type { ReactNode } from 'react'

export type TopLevelTablePageBodyProps = {
  header?: ReactNode
  children: ReactNode
}

export const TopLevelTablePageBody = ({ header, children }: TopLevelTablePageBodyProps) => (
  <>
    {header}
    <div className='flex min-h-0 w-full min-w-fit flex-1 flex-col px-11 pb-6 pt-4'>{children}</div>
  </>
)
